/** Site-wide JavaScript definitions and settings */

GOOGLE_MAPS_API_KEY = 'AIzaSyDzUjFLyq2yTXtZaRIv0u_eiJi1ktGeYaU';
